import { SiteFooter } from "@/components/luminous/SiteFooter";

interface FooterProps {
  language: "es" | "en";
}

/**
 * Pie compartido del sitio. Delega en el pie de la dirección luminosa para que
 * la Home y todas las páginas interiores usen exactamente la misma pieza.
 */
export const Footer = ({ language }: FooterProps) => <SiteFooter language={language} />;

export default Footer;
